/**
 * Device Detection Utilities
 * Differentiates between Mobile Browser, Native App (Capacitor), and Desktop
 */

/**
 * Check if running in a Mobile Browser (NOT Capacitor Native App)
 *
 * @returns {boolean} true if mobile browser, false if native app or desktop
 */
export const isMobileBrowser = () => {
  // Check if running in Capacitor native app
  const isNativeApp = typeof window !== 'undefined' &&
                      window.Capacitor?.isNativePlatform?.();

  // Check if mobile viewport width
  const isMobileWidth = typeof window !== 'undefined' &&
                        window.innerWidth < 768;

  // Return true ONLY if mobile width AND NOT native app
  return isMobileWidth && !isNativeApp;
};

/**
 * Check if running in Capacitor Native App
 *
 * @returns {boolean} true if native app (iOS/Android)
 */
export const isNativeApp = () => {
  return typeof window !== 'undefined' &&
         window.Capacitor?.isNativePlatform?.() === true;
};

/**
 * Check if running on Desktop (width >= 768px)
 *
 * @returns {boolean} true if desktop viewport
 */
export const isDesktop = () => {
  return typeof window !== 'undefined' &&
         window.innerWidth >= 768;
};

/**
 * Get current platform type
 *
 * @returns {'mobile-browser' | 'native-app' | 'desktop'}
 */
export const getPlatformType = () => {
  if (isNativeApp()) return 'native-app';
  if (isMobileBrowser()) return 'mobile-browser';
  return 'desktop';
};
